import React from 'react';
import UserRow from '@/users/components/UserRow';

const SubscribersTableRows = ({ items, columns }) => (
  items.map((item, index) => (
    <UserRow
      key={`subscribers_table_row_${item.code}`}
      user={item}
      upward={index > 4}
      columns={columns}
    />
  ))
);

export default SubscribersTableRows;
